import { useSyncExternalStore } from 'react'

const query = window.matchMedia('(prefers-color-scheme: dark)')

function subscribe(callback: () => void) {
  query.addEventListener('change', callback)
  return () => query.removeEventListener('change', callback)
}

export function useSystemTheme(): 'light' | 'dark' {
  return useSyncExternalStore(subscribe, () => (query.matches ? 'dark' : 'light'))
}
